export const NETLOGINREPLY = {
    OK: 0,
    Failed: 1,
    InvalidUsername: 2,
    InvalidPassword: 3,
    AlreadyLoggedIn: 4,
    RefusedAccount: 5,
    NeedCharge: 6,
    NoRights: 7,
    Overloaded: 8,
    NoRealName: 9,
    BadVersion: 10,
    OutOfIp: 11,
};

export const PARTY_REQ_MAKE = 0x00;
export const PARTY_REQ_JOIN = 0x01;

// Outgoing (server -> client) 0x7d1 status codes.
export const PARTY_REPLY_ACCEPT_MAKE = 0x00;
export const PARTY_REPLY_NOT_FOUND = 0x01;
export const PARTY_REPLY_BUSY = 0x02;
export const PARTY_REPLY_REJECT_JOIN = 0x03;
export const PARTY_REPLY_DESTROY = 0x04;
export const PARTY_REPLY_FULL_MEMBERS = 0x05;
export const PARTY_REPLY_INVALID_LEVEL = 0x06;
export const PARTY_REPLY_CHANGE_OWNER = 0x07;
export const PARTY_REPLY_CHANGE_OWNERnDISCONN = 0x08;
export const PARTY_REPLY_NO_CHARGE_TARGET = 0x09;
export const PARTY_REPLY_DISCONNECT = 0x0a;
export const PARTY_REPLY_BAN = 0x0b;
export const PARTY_REPLY_SHARE_ENABLED = 0x0c;
export const PARTY_REPLY_SHARE_DISABLED = 0x0d;

// 0x7d7 party-rule bit flags.
export const PARTY_RULE_ITEM_TO_ORDER = 0x01;
export const PARTY_RULE_EXP_PER_PLAYER = 0x02;

// Sentinel for the 0x7d2 packet's member-count byte meaning "this is a
// leaver notification, not a full member list" (see gameclient.ts's 0x7d2
// handler).
export const PARTY_MEMBER_SUB = 0xff;

export const REPLY_GET_FIELDITEM_REPLY_OK = 0x00;
export const REPLY_GET_FIELDITEM_REPLY_NONE = 0x01;
export const REPLY_GET_FIELDITEM_REPLY_NO_RIGHT = 0x02;
export const REPLY_GET_FIELDITEM_REPLY_TOO_MANY = 0x03;

// Outgoing 0x730 quest request types.
export const TYPE_QUEST_REQ_DELETE = 0x02;
export const TYPE_QUEST_REQ_DO_TRIGGER = 0x03;

// Incoming quest reply result codes.
export const RESULT_QUEST_REPLY_ADD_SUCCESS = 0x01;
export const RESULT_QUEST_REPLY_ADD_FAILED = 0x02;
export const RESULT_QUEST_REPLY_DEL_SUCCESS = 0x03;
export const RESULT_QUEST_REPLY_DEL_FAILED = 0x04;
export const RESULT_QUEST_REPLY_TRIGGER_SUCCESS = 0x05;
export const RESULT_QUEST_REPLY_TRIGGER_FAILED = 0x06;
export const RESULT_QUEST_REPLY_UPDATE = 0x07;
export const RESULT_QUEST_REPLY_COMPLETE = 0x08;
export const RESULT_QUEST_REPLY_RESET = 0x09;
export const RESULT_QUEST_REPLY_DAILY_RESET = 0x0a;

// Incoming quest-item reward result codes.
export const RESULT_QUEST_REWARD_ADD_ITEM = 0x01;
export const RESULT_QUEST_REWARD_REMOVE_ITEM = 0x02;
